import React from 'react';
import {Image} from "react-bootstrap";
import styled from "styled-components";

const StyledImage = styled(Image)`
    max-width: 12rem;
    border-radius: 20%; /* Adjust this value to get the desired roundness */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(0, 0, 0, 0.1));
    background-clip: padding-box; /* Ensures the gradient doesn't bleed into the image */
`;

const BigLogo = () => {
    return (
        <StyledImage src="/assets/images/icon-512.png"></StyledImage>
    );
};

export default BigLogo;